import { useFormikContext } from 'formik';

import AppointmentMacroForm from './AppointmentMacroForm';
import FormMacroForm from './FormMacroForm';
import NoteMacroForm from './NoteMacroForm';
import TextMacroForm from './TextMacroForm';

const macroFormMap = {
  appointment_macro: AppointmentMacroForm,
  form_macro: FormMacroForm,
  note_macro: NoteMacroForm,
  text_macro: TextMacroForm
};

const UpsertModalForm = ({ macroType, footer }) => {
  const { submitForm, isSubmitting } = useFormikContext();

  const MacroFormComponent = macroFormMap[macroType];

  return (
    <>
      {MacroFormComponent ? <MacroFormComponent /> : null}

      {footer ? (
        <div className="Modal__footer flex justify-center border-0 bg-primary-10 !p-0 shadow-none">
          <div className="flex justify-center">{footer({ submit: submitForm, isSubmitting })}</div>
        </div>
      ) : null}
    </>
  );
};

export default UpsertModalForm;
